var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_18)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#181F25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1758 13C36.8901 13 14.4725 16.8333 7 24.4999C10.7363 28.3333 23.8132 34.0833 46.2308 34.0833C68.9576 34.0833 150.616 30.25 158.319 30.25C165.791 30.25 173.264 34.0833 177 36L169.527 26.4167L177 14.9167C174.509 17.4722 167.286 20.6667 158.319 20.6667C147.11 20.6667 100.451 13 61.1758 13Z",
    fill: "url(#paint0_linear_4_18)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27,
    cy: 22.5,
    rx: 4,
    ry: 3.5,
    fill: "#181F25"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_18",
    x1: 92,
    y1: 13,
    x2: 92,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0D6FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.09f9b2e1bbb40a0664970be364fb9c0a.svg";
export { ForwardRef as ReactComponent };